import { Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';

import SuspendedIcon from '@swf/core/assets/icons/warning.svg';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../VerifyAccount.scss';

import {
  TXTWCL_Already_sent_us_your_ID_detail_ELL,
  TXTWCL_Important_information_about_yo_ELL,
  TXTWCL_Just_so_you_know,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL,
  TXTWCL_To_get_things_back_up_and_runn_ELL,
  TXTWCL_WeXve_had_to_suspend_your_acco_ELL
} from './AMLSuspended.messages.json';

interface Props {
  userId: string;
  suspendedOnly?: boolean;
}

const AMLSuspended: React.FC<Props> = ({ userId, suspendedOnly }) => (
  <>
    <span className={styles.amlTitle}>
      <Translation {...TXTWCL_Important_information_about_yo_ELL} values={{ 0: userId }} />
    </span>
    <Translation tagName="p" {...TXTWCL_WeXve_had_to_suspend_your_acco_ELL} />
    <StarsInfo className={styles.amlInfo} type="error">
      <div className={styles.infoHeader}>
        <SuspendedIcon width="20" height="20" />
        <Translation tagName="b" {...TXTWCL_Just_so_you_know} />
      </div>
      <Translation {...TXTWCL_This_means_you_wonXt_be_able_t_ELL} />
    </StarsInfo>
    {suspendedOnly ? (
      <Translation tagName="p" {...TXTWCL_To_get_things_back_up_and_runn_ELL} />
    ) : (
      <>
        <span className={styles.suspendedInfo}>
          <Translation tagName="b" {...TXTWCL_To_get_things_back_up_and_runn_ELL} />
        </span>
        <span className={styles.amlBodyBottom}>
          <Translation {...TXTWCL_Already_sent_us_your_ID_detail_ELL} />
        </span>
      </>
    )}
  </>
);

export default AMLSuspended;
